<script setup lang="ts">
import { computed } from 'vue'

import { useSession } from '../composables/useSession'

const { me } = useSession()

// 企业类型只有 operator 是平台运营方，其余一律按货主企业展示
const tenantType = computed(() => (me.value?.tenant.type === 'operator' ? '平台运营方' : '货主企业'))
</script>

<!--
  个人中心的信息卡。抽到 ui-kit 是因为顶栏的「个人中心」下拉项在所有壳里都指向 /profile，
  早先只有 portal 有这个页面，子系统点进去就是 404（wms.yc.sasago.com/profile 页面不存在）。
  各 app 的 views/Profile.vue 只做薄封装，不再各抄一份。
-->
<template>
  <el-card class="yc-profile-card">
    <template #header>
      <b>个人中心</b>
    </template>

    <el-descriptions :column="1" border>
      <el-descriptions-item label="姓名">{{ me?.name || '—' }}</el-descriptions-item>
      <el-descriptions-item label="用户名">
        <span class="yc-mono">{{ me?.username || '—' }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="所属企业">
        {{ me?.tenant?.name || '—' }}
        <span v-if="me?.tenant?.code" class="yc-mono">（{{ me.tenant.code }}）</span>
      </el-descriptions-item>
      <el-descriptions-item label="企业类型">{{ tenantType }}</el-descriptions-item>
      <!--
        这里展示的是密码状态而不是登录时间：/me 没有 last_login 字段，
        旧代码把 must_change_pwd 挂在「最近登录」标签下属于文案错位，一并改对。
      -->
      <el-descriptions-item label="密码状态">
        {{ me?.must_change_pwd ? '待修改密码' : '正常' }}
      </el-descriptions-item>
    </el-descriptions>
  </el-card>
</template>